import { jsPDF } from 'jspdf';

import STRABAG from '../assets/pdf-logos/LOGO_STRABAG.png';
import HAGEDORN from '../assets/pdf-logos/LOGO_HAGEDORN.png';
import ANTON_MEYER from '../assets/pdf-logos/LOGO_ANTON_MEYER.png';
import SB from '../assets/pdf-logos/LOGO_SB.png';
import STUTTGART from '../assets/pdf-logos/LOGO_STUTTGART.png';

const PINK = [238, 33, 86];
const DARK = [30, 30, 30];
const GREY = [120, 120, 120];

const formatEuro = value => `${value.toLocaleString('de-DE')} €`;

export function generateRiskReportPdf(score) {
  const gPct = Math.max(0, Math.min(100, Math.round(Number(score) || 0)));

  const doc = new jsPDF({ unit: 'mm', format: 'a4' });

  const riskLabel =
    gPct < 35 ? 'Niedriges Risiko' : gPct < 65 ? 'Mittleres Risiko' : 'Hohes Risiko';

  const riskColor =
    gPct < 35 ? [63, 109, 17] : gPct < 65 ? [133, 79, 11] : [163, 45, 45];

  const barColor =
    gPct < 35 ? [99, 153, 34] : gPct < 65 ? [186, 117, 23] : [226, 75, 74];

  const sMin = gPct < 35 ? 2000 : gPct < 65 ? 8000 : 18000;
  const sMax = gPct < 35 ? 8000 : gPct < 65 ? 25000 : 48500;

  // Header
  doc.setFillColor(...PINK);
  doc.rect(0, 0, 210, 18, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('GuardUp – Baustellenrisiko-Bericht', 14, 11);

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('guardup.de', 196, 11, { align: 'right' });

  // Risk result
  doc.setTextColor(...DARK);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('Dein Risiko-Ergebnis', 14, 34);

  doc.setTextColor(...riskColor);
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text(riskLabel, 14, 44);

  doc.setTextColor(...DARK);
  doc.setFontSize(36);
  doc.setFont('helvetica', 'bold');
  doc.text(String(gPct), 14, 62);

  doc.setTextColor(...GREY);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text('von 100 Risikopunkten', 38, 62);

  // Risk bar
  doc.setFillColor(230, 230, 230);
  doc.roundedRect(14, 68, 182, 4, 2, 2, 'F');

  doc.setFillColor(...barColor);
  doc.roundedRect(14, 68, Math.round(182 * (gPct / 100)), 4, 2, 2, 'F');

  // Financial risk
  doc.setTextColor(...DARK);
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('Finanzielle Risikoeinschätzung', 14, 86);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...GREY);
  doc.text('Geschätztes Schadensrisiko (einzelner Vorfall)', 14, 95);

  doc.setTextColor(...riskColor);
  doc.setFont('helvetica', 'bold');
  doc.text(`${formatEuro(sMin)} – ${formatEuro(sMax)}`, 196, 95, { align: 'right' });

  doc.setTextColor(...GREY);
  doc.setFont('helvetica', 'normal');
  doc.text('Möglicher Gesamtschaden pro Saison', 14, 103);

  doc.setTextColor(...DARK);
  doc.setFont('helvetica', 'bold');
  doc.text(
    `${formatEuro(Math.round(sMin * 1.5))} – ${formatEuro(Math.round(sMax * 2.5))}`,
    196,
    103,
    { align: 'right' }
  );

  doc.setDrawColor(220, 220, 220);
  doc.line(14, 110, 196, 110);

  // Next step
  doc.setTextColor(...DARK);
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('Nächster Schritt', 14, 120);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...GREY);
  doc.text(
    'Buche einen kostenlosen Termin mit einem GuardUp-Experten für eine vollständige',
    14,
    129
  );
  doc.text('Risikoprüfung deines Standorts.', 14, 136);

  doc.setTextColor(...PINK);
  doc.setFont('helvetica', 'bold');
  doc.text(
    'cal.com/david-guardup.de/termin-zum-kostenlosen-risiokocheck-ihres-standorts',
    14,
    144
  );

  // About GuardUp
  let yPos = 156;

  doc.setTextColor(...DARK);
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('Über GuardUp', 14, yPos);
  yPos += 8;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...GREY);

  const aboutText =
    'GuardUp ist Deutschlands unabhängige Plattform für temporäre Baustellen-Sicherheit. Wir prüfen Standortrisiken, vergleichen Anbieter und empfehlen die Lösung, die wirklich zu deinem Standort passt – neutral und herstellerunabhängig.';

  const aboutLines = doc.splitTextToSize(aboutText, 182);
  doc.text(aboutLines, 14, yPos);
  yPos += aboutLines.length * 4.8 + 4;

  const bullets = [
    'Unabhängige Plattform, kein einzelner Anbieter',
    'Kostenlose Risikoeinschätzung für Bauleiter und Projektmanager',
    'Bereits genutzt von Bauleitern und Projektmanagern in ganz Deutschland',
  ];

  doc.setFontSize(9.5);

  bullets.forEach(bullet => {
    doc.setTextColor(...PINK);
    doc.setFont('helvetica', 'bold');
    doc.text('•', 14, yPos);

    doc.setTextColor(...DARK);
    doc.setFont('helvetica', 'normal');
    doc.text(bullet, 19, yPos);

    yPos += 6;
  });

  yPos += 4;

  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...GREY);
  doc.text(
    'Bereits von Bauleitern und Projektmanagern in ganz Deutschland genutzt',
    14,
    yPos
  );
  yPos += 6;

  // Trust logos – same layout as old PDF
  const logos = [
    { data: STRABAG, w: 948, h: 338 },
    { data: HAGEDORN, w: 468, h: 150 },
    { data: ANTON_MEYER, w: 1186, h: 406 },
    { data: SB, w: 232, h: 232 },
    { data: STUTTGART, w: 219, h: 209 },
  ];

  const rowW = 182;
  const gapW = 4;
  const n = logos.length;
  const colW = (rowW - gapW * (n - 1)) / n;
  const boxH = 12;

  logos.forEach((logo, index) => {
    const colX = 14 + index * (colW + gapW);
    const ratio = logo.w / logo.h;

    let drawW = colW;
    let drawH = colW / ratio;

    if (drawH > boxH) {
      drawH = boxH;
      drawW = boxH * ratio;
    }

    const x = colX + (colW - drawW) / 2;
    const y = yPos + (boxH - drawH) / 2;

    doc.addImage(logo.data, 'PNG', x, y, drawW, drawH);
  });

  yPos += boxH + 10;

  // Disclaimer
  doc.setFillColor(245, 245, 245);
  doc.roundedRect(14, yPos, 182, 18, 3, 3, 'F');

  doc.setTextColor(...GREY);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text(
    'Risikoeinschätzung basiert auf Branchen-Benchmarks (Boels Rental 2026, Polizei Brandenburg).',
    14,
    yPos + 8
  );
  doc.text(
    'Kein Anspruch auf Vollständigkeit. Individuelle Einschätzung durch GuardUp kann abweichen.',
    14,
    yPos + 14
  );

  // Footer
  doc.setFillColor(...PINK);
  doc.rect(0, 282, 210, 15, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.text(
    'guardup.de  ·  Deutschlands unabhängige Plattform für temporäre Baustellen-Sicherheit',
    105,
    291,
    { align: 'center' }
  );

  doc.save('GuardUp-Risikobericht.pdf');
}

export default generateRiskReportPdf;
